import { createContext, useContext, useState, useCallback } from "react";

const translations = {
  nl: {
    // AgeGate
    "age.brand": "Fetshop.nl",
    "age.title": "Alleen voor volwassenen",
    "age.body": "Deze website bevat expliciet materiaal voor volwassenen. Door verder te gaan bevestig je dat je 18 jaar of ouder bent en akkoord gaat met het bekijken van erotische content.",
    "age.yes": "Ja, ik ben 18 jaar of ouder",
    "age.no": "Nee, verlaat de site",
    "age.anon": "100% Anoniem",
    "age.discreet": "Discreet",
    // Header
    "nav.discreet_on": "Discreet aan",
    "nav.discreet_off": "Discreet uit",
    "nav.place": "Plaats advertentie",
    "nav.login": "Inloggen",
    "menu.dashboard": "Mijn dashboard",
    "menu.favorites": "Favorieten",
    "menu.messages": "Berichten",
    "menu.bids": "Mijn biedingen",
    "menu.revenue": "Omzetoverzicht",
    "menu.moderation": "Gesprekken meelezen",
    "menu.logout": "Uitloggen",
    // Home
    "home.badge": "Discrete Marktplaats voor Intimiteit",
    "home.title1": "Koop & verkoop erotiek,",
    "home.title2": "discreet en veilig",
    "home.subtitle": "Ontdek een luxe marktplaats voor nieuwe en tweedehands intieme producten. Anoniem contact, geverifieerde verkopers.",
    "home.search": "Zoek naar producten...",
    "home.trust_anon": "100% Anoniem contact",
    "home.trust_ship": "Discrete verzending",
    "home.trust_verified": "Geverifieerde verkopers",
    "home.all": "Alles",
    "home.filters": "Filters",
    "home.all_conditions": "Alle staten",
    "home.sort_recent": "Nieuwste eerst",
    "home.sort_price_asc": "Prijs laag → hoog",
    "home.sort_price_desc": "Prijs hoog → laag",
    "home.clear": "Wis filters",
    "home.empty_title": "Geen advertenties gevonden",
    "home.empty_sub": "Wees de eerste die een product plaatst.",
    "home.promo": "Lanceeractie: alle advertenties tijdelijk gratis te plaatsen!",
    // Auth
    "auth.secure": "Discreet & Veilig",
    "auth.welcome_back": "Welkom terug",
    "auth.create": "Maak een account",
    "auth.name": "Naam of alias",
    "auth.phone": "Telefoon (optioneel)",
    "auth.email": "E-mailadres",
    "auth.password": "Wachtwoord",
    "auth.wait": "Even geduld...",
    "auth.login": "Inloggen",
    "auth.register": "Registreren",
    "auth.no_account": "Nog geen account?",
    "auth.has_account": "Al een account?",
    "auth.welcome_toast": "Welkom bij Fetshop.nl",
    "auth.forgot_link": "Wachtwoord vergeten?",
    "auth.forgot_title": "Wachtwoord herstellen",
    "auth.forgot_intro": "Vul je e-mailadres in. We sturen je een link om een nieuw wachtwoord in te stellen.",
    "auth.forgot_submit": "Stuur herstel-link",
    "auth.forgot_sent": "Als dit e-mailadres bij ons bekend is, ontvang je zo een herstel-link.",
    "auth.back_to_login": "Terug naar inloggen",
    // Product detail
    "pd.back": "Terug",
    "pd.views": "weergaven",
    "pd.description": "Beschrijving",
    "pd.chat_seller": "Chat met verkoper",
    "pd.contact_note": "Neem eerst via de site contact op. Telefoonnummers en e-mail worden pas ná het eerste bericht in de chat gedeeld — zo blijf je veilig en anoniem.",
    "pd.responds": "Reageert meestal binnen 1 uur",
    "pd.own": "Dit is jouw eigen advertentie. Beheer hem via je",
    "pd.dashboard": "dashboard",
    "pd.safety": "Spreek af op een veilige plek en betaal nooit vooraf zonder garantie.",
  },
  en: {
    "age.brand": "Fetshop.nl",
    "age.title": "Adults only",
    "age.body": "This website contains explicit adult material. By continuing you confirm that you are 18 years or older and agree to view erotic content.",
    "age.yes": "Yes, I am 18 or older",
    "age.no": "No, leave the site",
    "age.anon": "100% Anonymous",
    "age.discreet": "Discreet",
    "nav.discreet_on": "Discreet on",
    "nav.discreet_off": "Discreet off",
    "nav.place": "Post listing",
    "nav.login": "Sign in",
    "menu.dashboard": "My dashboard",
    "menu.favorites": "Favourites",
    "menu.messages": "Messages",
    "menu.bids": "My bids",
    "menu.revenue": "Revenue overview",
    "menu.moderation": "Read conversations",
    "menu.logout": "Sign out",
    "home.badge": "Discreet Marketplace for Intimacy",
    "home.title1": "Buy & sell eroticism,",
    "home.title2": "discreet and safe",
    "home.subtitle": "Discover a luxury marketplace for new and second-hand intimate products. Anonymous contact, verified sellers.",
    "home.search": "Search for products...",
    "home.trust_anon": "100% Anonymous contact",
    "home.trust_ship": "Discreet shipping",
    "home.trust_verified": "Verified sellers",
    "home.all": "All",
    "home.filters": "Filters",
    "home.all_conditions": "All conditions",
    "home.sort_recent": "Newest first",
    "home.sort_price_asc": "Price low → high",
    "home.sort_price_desc": "Price high → low",
    "home.clear": "Clear filters",
    "home.empty_title": "No listings found",
    "home.empty_sub": "Be the first to post a product.",
    "home.promo": "Launch promo: all listings temporarily free to post!",
    "auth.secure": "Discreet & Secure",
    "auth.welcome_back": "Welcome back",
    "auth.create": "Create an account",
    "auth.name": "Name or alias",
    "auth.phone": "Phone (optional)",
    "auth.email": "Email address",
    "auth.password": "Password",
    "auth.wait": "Please wait...",
    "auth.login": "Sign in",
    "auth.register": "Register",
    "auth.no_account": "No account yet?",
    "auth.has_account": "Already have an account?",
    "auth.welcome_toast": "Welcome to Fetshop.nl",
    "auth.forgot_link": "Forgot password?",
    "auth.forgot_title": "Reset your password",
    "auth.forgot_intro": "Enter your email and we'll send you a link to set a new password.",
    "auth.forgot_submit": "Send reset link",
    "auth.forgot_sent": "If this email is known to us, you'll receive a reset link shortly.",
    "auth.back_to_login": "Back to sign in",
    "pd.back": "Back",
    "pd.views": "views",
    "pd.description": "Description",
    "pd.chat_seller": "Chat with seller",
    "pd.contact_note": "Make contact through the site first. Phone numbers and email are only shared in the chat after the first message — so you stay safe and anonymous.",
    "pd.responds": "Usually responds within 1 hour",
    "pd.own": "This is your own listing. Manage it from your",
    "pd.dashboard": "dashboard",
    "pd.safety": "Meet in a safe place and never pay in advance without a guarantee.",
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("velvet_lang") || "nl");
  const setLang = useCallback((l) => {
    localStorage.setItem("velvet_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key) => (translations[lang] && translations[lang][key]) || translations.nl[key] || key, [lang]);
  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
